
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#e0e4ec","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/mobile"}},[_c('path',{attrs:{"data-name":"Vector","d":"M16.666 5.834v8.333c0 3.333-.833 4.167-4.167 4.167h-5c-3.333 0-4.166-.834-4.166-4.167V5.834c0-3.334.833-4.167 4.167-4.167h5c3.333 0 4.166.833 4.166 4.167z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.666 4.584H8.333M11.291 14.626A1.292 1.292 0 1110 13.334a1.292 1.292 0 011.291 1.292z","opacity":".4"}})])])
          )
        }
      }
    